import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import TextInputFieldWithValidation from '../../../ValidationFormElements/TextInputFieldWithValidation';

const ForeignLanguageAddressFields = ({
  showEngAddress,
  formProps,
  form,
  handleStreetEnChange,
  disabledInputs,
  handleStreetChange,
}) => (
  <>
    {showEngAddress && (
    <Grid item xs={12}>
      <TextInputFieldWithValidation
        required
        formProps={formProps}
        labelKey="contactInfo.addressEn"
        name="streetEn"
        value={form.streetEn}
        handleChange={(e) => handleStreetEnChange(e.target.value)}
      />
    </Grid>
    )}
    <Grid item xs={12}>
      <TextInputFieldWithValidation
        required
        disabled={disabledInputs.includes('street')}
        formProps={formProps}
        labelKey="contactInfo.address"
        name="street"
        value={form.street}
        handleChange={(e) => handleStreetChange(e.target.value)}
      />
    </Grid>
  </>
);

ForeignLanguageAddressFields.propTypes = {
  disabledInputs: PropTypes.arrayOf(PropTypes.string).isRequired,
  formProps: PropTypes.shape({
    register: PropTypes.func,
    setValue: PropTypes.func,
    getValues: PropTypes.func,
    errors: PropTypes.shape({}),
    clearError: PropTypes.func,
    triggerValidation: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    streetEn: PropTypes.string,
    street: PropTypes.string,
  }).isRequired,
  showEngAddress: PropTypes.bool.isRequired,
  handleStreetEnChange: PropTypes.func.isRequired,
  handleStreetChange: PropTypes.func.isRequired,
};

export default ForeignLanguageAddressFields;
